import { Mutation } from 'vuex'
import { RootState } from '../types'

const setOnline: Mutation<RootState> = (state, payload) => {
  state.isOnline = payload
}

export default setOnline
